import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Modal, Button, Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";

function BookAnAppointment() {
  const { userid } = useParams();
  const [labs, setLabs] = useState([]);
  const [selectedLab, setSelectedLab] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [date, setDate] = useState("");
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(true);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [companyRes, setCompanyRes] = useState(true);
  const [tests, setTests] = useState(null);
  const [employee, setEmployee] = useState("");
  const [packages, setPackages] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [packageId, setPackageId] = useState("");
  const [additionalTestIds, setAdditionalTestIds] = useState([]);
  const navigate = useNavigate();
  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/labdetails/searchLabsForAppointment/regulated=true/empUserid=${userid}`;
      const requestData = { searchTerm };
      const response = await axios.post(searchUrl, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabs(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(
        `/api/labdetails/getAllLabsForAppointment/regulated=true/empUserid=${userid}`,
        {
          params: { page: pageNumber },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setLabs(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployee(empRes.data);

      const compRes = await axios.get(
        `/api/companydetails/${empRes.data?.companyId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCompanyRes(compRes.data);

      const testRes = await axios.get(`/api/labtest`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabTests(testRes.data);

      if (
        compRes.data.packageByAge === false &&
        compRes.data.restrictedPkgByDesignation === false
      ) {
        const pkgResponse = await axios.get(
          `/api/package/companyId=${empRes.data?.companyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPackages(pkgResponse.data);
      } else {
        const response = await axios.get(
          `/api/packagedesignationmapping/employee=${userid}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTests(response.data.pac?.packagename);
        setPackageId(response.data.packageid);
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
    fetchData();
  }, []);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleBookAppointment = async () => {
    if (!date && packageId) {
      toast.warn("Please select a date");
      return;
    }
    if (!packageId && date) {
      toast.warn("Please select a package");
      return;
    }
    if (!packageId && !date) {
      toast.warn("Please select a date and package");
      return;
    }

    const selectedDate = new Date(date);
    const currentDate = new Date();
    const oneDayFromNow = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 1
    );

    if (userRole !== "ROLE_SUPER" && userRole !== "ROLE_ADMIN") {
      if (selectedDate < oneDayFromNow || selectedDate.getDay() === 0) {
        toast.warn(
          "Please select a weekday other than Sunday and ensure the date is at least 1 day from today."
        );
        return;
      }
    }

    if (selectedDate.getDay() === 0) {
      toast.warn("Please select a weekday other than Sunday.");
      return;
    }

    setShowWarningModal(true);
  };

  const handleShowConfirmationModal = async () => {
    setShowConfirmationModal(true);
  };

  const confirmBookAppointment = async () => {
    if (companyRes.requireEmpPayment === true) {
 const data = {
      packageId: packageId || null,
      additionalTestIds:
        additionalTestIds.length > 0 ? additionalTestIds : null,
      userid: userid,
      labId: selectedLab.id,
      userid: userid,
      appointmentDate: date,
    };
      navigate("/users/razorpay", { state: data });
    } else {
      try {
        setLoader(true);
        await axios.post(
          "/api/employeeappointment/create",
          {
            userid: userid,
            labId: selectedLab.id,
            date,
            packageid: packageId,
            additionalTest: additionalTestIds.map((id) => ({ testId: id })),
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Appointment Booked successfully");
        if (userRole === "ROLE_EMPLOYEE") {
          navigate("/users/employee-appointments");
        } else {
          navigate(`/users/employee-profile/${userid}`);
        }
      } catch (error) {
        setLoader(false);
        handleError(error);
      } finally {
        setShowConfirmationModal(false);
      }
    }
  };

  const handlePackageSelection = async (e) => {
    const selectedPackageId = e.target.value;
    setPackageId(selectedPackageId);
    if (selectedPackageId) {
      try {
        setLoader(true);
        const response = await axios.get(`/api/package/${selectedPackageId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTests(response.data.packagename);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    }
  };

  // ✅ Handle adding new tests
  const handleAdditionalTestSelection = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue && !additionalTestIds.includes(selectedValue)) {
      setAdditionalTestIds((prev) => [...prev, selectedValue]);
    }
  };

  // ✅ Remove selected test
  const handleRemoveTest = (id) => {
    setAdditionalTestIds((prev) => prev.filter((tid) => tid !== id));
  };

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleUseMyLocation = async (pageNumber = 0) => {
    setLoader(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await axios.get(`/api/labdetails/nearByLocation`, {
              params: {
                latitude,
                longitude,
                radius: 10,
                empUserid: userid,
                page: pageNumber,
              },
              headers: { Authorization: `Bearer ${token}` },
            });

            setLabs(response.data.content);
            setCurrentPage(response.data.number);
            setTotalPages(response.data.totalPages);
            setLoader(false);
          } catch (error) {
            setLoader(false);
            handleError(error);
          }
        },
        (error) => {
          handleError(error);
          setLoader(false);
        }
      );
    } else {
      setLoader(false);
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="card card-raised">
                <div className="card-body">
                  <div className="card-title form-group d-flex align-items-center justify-content-between">
                    <span>Choose Lab</span>
                    <div className="d-flex align-items-center">
                      <div
                        className="form-group position-relative"
                        style={{ width: "300px", marginRight: "10px" }}
                      >
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search by lab name, code, city, pincode"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ paddingLeft: "2rem", width: "100%" }}
                        />
                        <span
                          className="position-absolute"
                          style={{
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </span>
                      </div>
                      <Button
                        variant="outline-primary"
                        onClick={() => handleUseMyLocation(0)}
                      >
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> Use My
                        Location
                      </Button>
                    </div>
                  </div>

                  <div className="row mt-5">
                    {labs.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      labs.map((lab) => (
                        <div className="col-md-4 mb-4" key={lab.id}>
                          <div
                            className={`card ${
                              selectedLab && selectedLab.id === lab.id
                                ? "border-primary"
                                : ""
                            }`}
                            onClick={() => setSelectedLab(lab)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={lab.image}
                              className="card-img-top"
                              alt={lab.name}
                            />
                            <div className="card-body">
                              <h5 className="card-title mb-2">
                                {lab.labname}
                              </h5>
                              <p className="card-text">
                                Lab Code: {lab.labcode}
                              </p>
                              <p className="card-text">
                                Contact Number: {lab.contact}
                              </p>
                              <p className="card-text">
                                Address: {lab.addressLine1},{" "}
                                {lab.addressLine2}
                              </p>
                              <p className="card-text">
                                {lab.city}, {lab.pincode}, {lab.state}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  <div className="d-flex justify-content-center">
                    <Pagination>
                      <Pagination.First
                        onClick={() => handlePageChange(0)}
                        disabled={currentPage === 0}
                      />
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 0}
                      />
                      {renderPageNumbers()}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages - 1}
                      />
                      <Pagination.Last
                        onClick={() => handlePageChange(totalPages - 1)}
                        disabled={currentPage === totalPages - 1}
                      />
                    </Pagination>
                  </div>

                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={() => setStep(2)}
                        disabled={!selectedLab}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="row">
            <div className="col-6 mx-xl-auto">
              <div className="card card-raised">
                <div className="card-body">
                  <div className="card-title mb-2">Book Lab Appointment</div>
                  {selectedLab && (
                    <div>
                      <p>Selected Lab: {selectedLab.labname}</p>
                      <p>
                        Selected Package: {tests}
                        {tests !== null && (
                          <span style={{ marginLeft: "40px" }}>
                            <FiInfo
                              onClick={() => openTestsModal(packageId)}
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        )}
                      </p>

                      {companyRes.restrictedPkgByDesignation ===
                        false &&
                        companyRes.packageByAge === false && (
                          <div className="row mt-3">
                            <div className="col-md-6 mb-3">
                              <label htmlFor="package">
                                Select Package{" "}
                                <span style={{ color: "red" }}>* </span>
                              </label>
                              <select
                                id="package"
                                className="form-select"
                                value={packageId}
                                onChange={handlePackageSelection}
                              >
                                <option value="">-- Select --</option>
                                {packages.map((pkg) => (
                                  <option key={pkg.id} value={pkg.id}>
                                    {pkg.packagename}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                                              {/* ✅ Select Additional Tests */}
                      {companyRes.pilotOrganization === true && (
                      <div className="row mt-3">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="additionalTest">
                            Select Additional Tests
                          </label>
                          <select
                            id="additionalTest"
                            className="form-select"
                            value=""
                            onChange={handleAdditionalTestSelection}
                          >
                            <option value="">-- Select a test --</option>
                            {labTests.map((test) => (
                              <option key={test.id} value={test.id}>
                                {test.testname} - {test.testCat?.categoryname}
                              </option>
                            ))}
                          </select>

                          {additionalTestIds.length > 0 && (
                            <div className="mt-3">
                              <strong>Selected Tests:</strong>
                              <ul className="list-group mt-2">
                                {additionalTestIds.map((id) => {
                                  const selectedTest = labTests.find(
                                    (t) => t.id === Number(id)
                                  );
                                  return (
                                    <li
                                      key={id}
                                      className="list-group-item d-flex justify-content-between align-items-center"
                                    >
                                      {selectedTest?.testname || "Unknown Test"}
                                      <button
                                        type="button"
                                        className="btn btn-sm"
                                        onClick={() => handleRemoveTest(id)}
                                      >
                                        ❌
                                      </button>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      )}

                      <div className="row mt-3">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date">
                            Select Date{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 d-flex justify-content-between">
                          <button
                            className="btn btn-secondary"
                            onClick={() => setStep(1)}
                          >
                            Back
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={handleBookAppointment}
                          >
                            Book Appointment
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

 return (
    <div>
      <div>
        <AdminDashboard />
      </div>
      <div className="col-12 mx-xl-auto ps-xl-10" style={{ marginTop: "10%" }}>
        <div className="stepper-wrapper">
          <div className={`stepper-item ${step === 1 ? 'active' : ''}`}>
            <div className="step-counter">1</div>
            <div className="step-name">Select Lab</div>
          </div>
          <div className={`stepper-item ${step === 2 ? 'active' : ''}`}>
            <div className="step-counter">2</div>
            <div className="step-name">Book Appointment</div>
          </div>
        </div>
        {renderStepContent(step)}
        {loader && <div className="loading"></div>}
      </div>

      {isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}

      {/* Modal for 10-hour fasting warning */}
      <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        Please ensure that the employee is fasting for at least 10 hours before taking the test.
        
      {companyRes.requireEmpPayment===true &&(
        <>
        <br/> <br/>
        <p style={{ color: 'red' }}>
        Please note, in case of appointment cancellation, the charges of platform fee will not be refunded.
        </p>
        </>
      )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-3" onClick={() => setShowWarningModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleShowConfirmationModal}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

 <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Consent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        On Confirmation of appointment with the selected lab, I hereby authorize the lab to upload 
        the medical reports to the TMPL web portal for Ashok Leyland.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-3" onClick={() => setShowConfirmationModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmBookAppointment}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default BookAnAppointment;
